import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TabStates} from "@app/features/product/product-detail/product-detail";
import {Product, StockHistory, StockHistoryCollection, StockHistoryFiltered} from "@app/core/interfaces";
import {BaseComponent} from "@app/core/bases";
import {takeUntil} from "rxjs";
import {StockService, UtilityService} from "@app/core/services";
import {Tag} from "primeng/tag";
import {TabsModule} from "primeng/tabs";
import {
    ProductDetailHistoriquesStock
} from "@app/features/product/product-detail-historiques-stock/product-detail-historiques-stock";
import {ProgressSpinner} from "primeng/progressspinner";

@Component({
  selector: 'app-product-detail-historiques',
    imports: [
        TabsModule,
        Tag,
        ProductDetailHistoriquesStock,
        ProgressSpinner
    ],
  templateUrl: './product-detail-historiques.html'
})
export class ProductDetailHistoriques extends BaseComponent implements OnInit, OnChanges{
    @Input() product!: Product;
    @Output() productChange: EventEmitter<Product> = new EventEmitter<Product>();

    @Input() tabStates!: TabStates[];
    @Output() tabStatesChange: EventEmitter<TabStates[]> = new EventEmitter<TabStates[]>();

    @Input() tabIndex!: number;

    activeTab: number = 0;
    subTabStates!: TabStates[];
    stockTabIndex: number = 0;

    stockHistoryFiltered!: StockHistoryFiltered[];

    isLoadingData: boolean = true;

    constructor(
        private stockService: StockService,
        public utilityService: UtilityService
    ) {
        super();
    }

    ngOnInit() {
        this.initTabs();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tabStates']) {
            const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
            if (tab.active && !tab.loaded) {
                this.getProductStocksHistoriques();
            }
        }
    }

    getProductStocksHistoriques(): void {
        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.stockService.getStockHistoriqueCollection({produit_id: this.product.id, page: 1, size: 100})
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (collection: StockHistoryCollection) => {
                    this.isLoadingData = false;
                    this.tabStates.map((state: TabStates) => {
                        if (state.index === this.tabIndex)
                            state.loaded = true
                    });
                    this.filterStockHistoriquesByStockId(collection.results);
                },
                complete: () => {
                    this.apiCall$?.unsubscribe();
                    this.productChange.emit(this.product)
                    this.initTabs();
                    this.isLoadingData = false;
                },
                error: () => {
                    this.apiCall$?.unsubscribe();
                    this.isLoadingData = false;
                }
            });
    }

    filterStockHistoriquesByStockId(collection: StockHistory[]): void {
        const stockHistoriques: StockHistoryFiltered[] = [];
        collection.forEach((historique) => {
            const stockId = historique.stock_id;
            const stockIsDeleted : boolean = historique.direction === 'SUPPRESSION';
            const existingStockHistorique = stockHistoriques.find((sh) => sh.stock_id === stockId);
            if (existingStockHistorique) {
                existingStockHistorique.historiques.push(historique);
                if(stockIsDeleted) {
                    existingStockHistorique.is_deleted = true;
                }
            } else {
                stockHistoriques.push({
                    stock_id: stockId,
                    etat: historique.etat,
                    etagere: historique.etagere,
                    rayon: historique.rayon,
                    secteur_nom: historique.secteur_nom,
                    is_deleted: stockIsDeleted,
                    historiques: [historique]
                });
            }
        });
        this.stockHistoryFiltered = stockHistoriques.sort((a, b) => a.is_deleted === b.is_deleted ? 0 : a.is_deleted ? 1 : -1);
        console.log(this.stockHistoryFiltered)
    }

    initTabs() {
        const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
        if (tab.active && tab.loaded) {
            if(this.product.stocks && this.product.stocks.length > 0) {
                this.activeTab = this.product.stocks[0].id;
                this.stockTabIndex = this.product.stocks[0].id;
            }

            this.subTabStates = this.product.stocks?.map((stock) => {
                return { index: stock.id as number, active: this.activeTab === stock.id, loaded: false }
            }) || [];

            this.tabStates.map((state: TabStates) => {
                if (state.index === this.tabIndex)
                    state.loaded = true
            });
        }
    }

    onTabChange(newIndex: string | number | undefined) {
        this.subTabStates.map((state) => state.active = state.index === newIndex);
        this.subTabStates = [...this.subTabStates]
    }
}
